module.exports = __webpack_public_path__ + "img/zhgjn_icon_pjp.png";